import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { getRequest, postRequest, putRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon, InfoIcon, ErrorIcon, TaskIcon, PermissionIcon, NeedIcon, BorrowItemIcon, EmergencyIcon, TechChangeIcon, UnseenIcon, SeenIcon, RefreshIcon } from "../svg/svgIcons";
import { DateTime } from "luxon";
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { getTimezone } from '../../utils/moduleSettings';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import * as XLSX from 'xlsx';
import AuthContext from '../../components/AuthContext';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from "primereact/avatargroup";
import { Tag } from 'primereact/tag';
import StatusIndicator, { MachineStateDot, getStatusIndicatorFilterValue } from '../../components/StatusIndicator';
import { useTabulatorScrollArrows } from '../../utils/useTabulatorScrollArrows';
import {
  cleanSorters,
  extractSafePaginationParams,
  createDedupedAjaxRequest,
  rowPassesMaintenanceTaskHeaderFilters,
  refreshProgressiveFromStart,
  mergeMaintenanceServiceTaskPagedListFiltersAndSorters,
  safeParse,
  TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS,
} from '../../utils/tabulatorProgressiveLoading';
import {
  applyServiceTaskColumnLayout,
  restoreServiceTaskUserMaskToTable,
} from '../../utils/tabulatorServiceTaskLayout';
import { getPusherChannel } from '../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { getEffectiveMask } from '../../utils/effectiveMask';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { buildTabulatorIdColumn } from '../../utils/tabulatorIdColumn';
import {
  TABULATOR_AUDIT_PROFILES,
  buildAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
} from '../../utils/tabulatorAuditColumns';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
const MAINTENANCE_TASK_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'editor': 'Common.TicketCreatedAt',
  'type': 'Common.Type',
  'is_unread': 'Common.Read',
  'defined_id': 'Common.TicketNumber',
  'theme': 'Common.Name',
  'status_id': 'Common.Status',
  'machine.name': 'Common.Machine',
  'waiting_for_action_by': 'ServiceTaskTable.Col.Deadline',
});



const MASK_PAGE = 'MaintenanceTaskStateList';

/** Poradie stĺpcov podľa field — musí sedieť s `columns` a s merge layoutu z masky. */
const TASK_STATE_LIST_COLUMN_FIELD_ORDER = Object.freeze([
  'editor',
  'status_indicator',
  'contractor_id',
  'id',
  'type',
  'is_unread',
  'defined_id',
  'theme',
  'machine.name',
  'status_id',
  'waiting_for_action_by',
  'created_at',
  'updated_at',
]);

const DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY = Object.freeze({
  editor: true,
  status_indicator: true,
  id: true,
  type: true,
  is_unread: true,
  defined_id: true,
  theme: true,
  'machine.name': true,
  status_id: true,
  waiting_for_action_by: true,
  created_at: true,
  updated_at: true,
});

function mergeTaskStateListColumnVisibilityFromSaved(saved) {
  const merged = mergeColumnVisibilityWithAuditDefaults(DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY, saved);
  return merged;
}

function applyTaskStateListDataColumnVisibility(table, visibility) {
  if (!table) return;
  table.hideColumn?.('contractor_id');
  for (const field of Object.keys(DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY)) {
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

export default function MaintenanceTaskStateList({preview=null}){

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,getUserColor,getUserInitials,getDateFormat, openChosenNotificationPreferences} = useContext(UtilContext);

    const canSetStandardMask = user?.permissions?.includes('set standard mask');
    const timezone = getTimezone(state?.module_settings || []);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFmt = `${dateFmt} HH:mm`;

    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [searchIconColor,setSearchIconColor] = useState("");
    const [visibleSearch,setVisibleSearch] = useState(false);
    const [searchValue,setSearchValue] = useState('');

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);


    const ref = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find((s) => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const pendingRowIdsRef = useRef(new Set());
    const rafRedrawRef = useRef(null);
    const needsRedrawRef = useRef(false);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);
    const isTableVisible = useCallback(() => {
        const table = getTable();
        if (!table) return false;
        const el = table.getElement?.() ?? table.element ?? table.rowManager?.element?.parentElement;
        return !!(el && el.offsetParent != null && el.clientHeight > 0);
    }, [getTable]);

    const scheduleRedraw = useCallback(() => {
        if (rafRedrawRef.current != null) return;
        rafRedrawRef.current = requestAnimationFrame(() => {
            const table = getTable();
            rafRedrawRef.current = null;
            if (!table) return;
            const ids = Array.from(pendingRowIdsRef.current);
            pendingRowIdsRef.current.clear();
            needsRedrawRef.current = false;
            const headerFilters = table.getHeaderFilters?.() ?? [];
            const opts = { service_states: state.service_states ?? [], userId: user?.id };
            ids.forEach((id) => {
                const row = table.getRow?.(id);
                if (!row) return;
                const data = row.getData?.();
                if (!data) return;
                if (!rowPassesMaintenanceTaskHeaderFilters(data, headerFilters, opts)) {
                    row.delete?.();
                    return;
                }
                row.reformat?.();
            });
        });
    }, [getTable, state.service_states, user?.id]);

    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator), filter_type: 'Error' };
        if (extra.size == null) extra.size = pageSizePc;
        mergeMaintenanceServiceTaskPagedListFiltersAndSorters(extra, {
            getTable,
            tableBuiltForParams: tableBuiltRef.current,
            userMaskFilters: preview == null ? state.user_mask_filters : null,
            maskPage: MASK_PAGE,
            service_states: state.service_states ?? [],
            userId: user?.id,
            module_settings: state?.module_settings,
            getDateFormat,
            definedIdMapsToTheme: true,
        });
        return extra;
    }, [state.service_states, state?.module_settings, state.user_mask_filters, user?.id, getDateFormat, preview, pageSizePc, getTable]);

    const normalizeText = (value) => (value ?? "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function matchAny(data, filterParams) {
      const search = normalizeText(filterParams.value || "");
      if (!search) return true;

      for (const key in data) {
        if (normalizeText(data[key]).includes(search)) {
          return true;
        }
      }
      return false;
    }

    function searchTable(){
      ref.current.setFilter(matchAny, { value: searchValue});
      setSearchIconColor("active");
      if (searchValue === " ") {
        ref.current.clearFilter()
      }
      setVisibleSearch(false);
    }

    const EditRowFormatter = (props) => {
        const rowData = props.cell.getRow().getData();

        const handleView = async () => {
            dispatch({
                type: 'create_new_tab',
                name: t('Util.Tab.ServiceTaskDetail'), translationKey: 'Util.Tab.ServiceTaskDetail', legacyLabel: t('Util.Tab.ServiceTaskDetail'),
                page: 'ServiceTaskDetail',
                props: { task: rowData, taskId: rowData?.id },
                mask: 'intr004'
            });
        };

        return (
            <div className="flex justify-center items-start w-full h-full">
                <button type="button" onClick={handleView}>
                    <EditRowIcon />
                </button>
            </div>
        );
    };

    function StatusIndicatorFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return (
            <div className="flex items-center justify-center w-full h-full">
                <StatusIndicator task={rowData} moduleSettings={state.module_settings} t={t} locale={locale} />
            </div>
        );
    }

    function MachineNameFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const machineName = rowData?.machine?.name ?? rowData['machine.name'] ?? '—';
        return (
            <div className="flex items-center min-w-0">
                <MachineStateDot task={rowData} t={t} locale={locale} />
                <span className="truncate" title={machineName}>{machineName}</span>
            </div>
        );
    }

    function TypeFormatter(props) {
        const rowData = props.cell.getRow().getData();
        switch(rowData.type){
            case 'Notification': {return <InfoIcon width={6} height={6}/>;}
            case 'Error': {return <ErrorIcon  width={6} height={6}/>;}
            case 'Task': {return <TaskIcon  width={6} height={6}/>;}
            case 'Permission': {return <PermissionIcon  width={6} height={6}/>;}
            case 'Need': {return <NeedIcon  width={6} height={6}/>;}
            case 'Borrow': {return <BorrowItemIcon  width={6} height={6}/>;}
            case 'Emergency': {return <EmergencyIcon  width={6} height={6}/>;}
            case 'TechChange': {return <TechChangeIcon  width={8} height={8}/>;}
            default: {return <InfoIcon  width={6} height={6}/>;}
        }
    }

    function StatusFormatter(props) {
        const rowData = props.cell.getRow().getData();

        // základný status podľa status_id
        let status = state.service_states.find(s => s.id === rowData.status_id);

        // fallback ak sa nenašiel status
        if (!status) {
            return (
                <Tag className="py-0.5 px-1 bg-gray-400">
                    <span className="text-base font-normal">{'Neznámy'}</span>
                </Tag>
            );
        }

        // 🔑 podmienka pre system_inspection
        if (status.phase === 'system_inspection') {
            const execStateId = rowData.execution?.executor_state;

            if (execStateId) {
                const execState = state.service_states.find(s => s.id == execStateId);
                if (execState && execState.phase === 'execution' && execState.transition_type === 'non_final') {
                    status = execState;
                }
            } else {
                // fallback podľa user_department
                let fallbackState = null;

                if (rowData.execution?.user_department === "user") {
                    fallbackState = state.service_states.find(s => s.id === 9); // Pridelený
                } else if (rowData.execution?.user_department === "department") {
                    fallbackState = state.service_states.find(s => s.id === 10); // Pridelený oddeleniu
                } else {
                    fallbackState = state.service_states.find(s => s.id === 7); // Schválený
                }

                if (fallbackState) {
                    status = fallbackState;
                }
            }
        }

        const hexColor = status.color ? `#${status.color}` : '#9ca3af';

        return (
            <Tag className="py-0.5 px-1" style={{ backgroundColor: hexColor }}>
                <span className="text-base font-normal">{status.name}</span>
            </Tag>
        );
    }

    function AwaitingUserFormatter(props) {
        const rowData = props.cell.getRow().getData();

        const STATUS = {
            UZAVRENY: 28,
            NESCHVALENY: 18,
            STORNOVANY: 30,
            // prípadne ďalšie
        };

        const deadline = rowData?.deadline
            ? DateTime.fromISO(rowData.deadline)
            : null;
        const today = DateTime.now().setZone(timezone).startOf("day");
        const isExpired = deadline && deadline < today;
        const isClosedStatus = Object.values(STATUS).includes(rowData?.status_id);

        const users = rowData.awaiting_user || [];
        const maxVisible = 3;

        const visibleUsers = users.slice(0, maxVisible);
        const extraUsers = users.slice(maxVisible);
        const extraCount = extraUsers.length;

        const extraNames = extraUsers
            .map((user) => user?.employee?.name || user?.username)
            .filter(Boolean);

        return (
            <div className="flex items-center justify-start w-full h-full">
                {!isClosedStatus && users.length > 0 && (
                    <AvatarGroup>
                        {visibleUsers.map((user) => (
                            <Avatar
                                key={user.id}
                                title={user?.employee?.name || user?.username}
                                label={getUserInitials(
                                    user?.employee?.name || user?.username
                                )}
                                shape="circle"
                                style={{
                                    backgroundColor: getUserColor(user?.username),
                                    color: "#ffffff",
                                    marginRight: "5px",
                                }}
                            />
                        ))}

                        {extraCount > 0 && (
                            <Avatar
                                label={`+${extraCount}`}
                                shape="circle"
                                // keď podržíš myš, ukáže mená tých "skrytých"
                                title={extraNames.join("\n")}
                                style={{
                                    backgroundColor: "#6b7280", // neutrálna sivá
                                    color: "#ffffff",
                                    marginRight: "5px",
                                }}
                            />
                        )}
                    </AvatarGroup>
                )}

                {deadline && (
                    <div
                        className={
                            isExpired && !isClosedStatus
                                ? "text-red-500 font-semibold ml-1"
                                : "ml-1"
                        }
                    >
                        {deadline.toFormat(dateFmt)}
                    </div>
                )}
            </div>
        );
    }

    // sorter funkcia
    function awaitingUserSorter(a, b, rowA, rowB) {
        const dataA = rowA.getData();
        const dataB = rowB.getData();

        const deadlineA = dataA?.deadline
            ? DateTime.fromISO(dataA.deadline)
            : null;
        const deadlineB = dataB?.deadline
            ? DateTime.fromISO(dataB.deadline)
            : null;

        if (deadlineA && deadlineB) {
            if (deadlineA < deadlineB) return -1;
            if (deadlineA > deadlineB) return 1;
            return 0;
        }

        if (deadlineA && !deadlineB) return -1; // A má dátum, B nie
        if (!deadlineA && deadlineB) return 1;  // B má dátum, A nie

        return 0; // obaja nemajú deadline
    }


    const markAsViewed = async (taskId, value) => {
        const formData = new FormData();
        formData.append("task_id", taskId);
        formData.append("user_id", user.id);
        const url = !value
            ? `/api/service_tasks/${taskId}/mark-as-viewed`
            : `/api/service_tasks/${taskId}/mark-as-not-viewed`;
        try {
            await postRequest(url, formData, true);
            dispatch({ type: "updateTaskViewed", payload: taskId, value: value });
        } catch (err) {
            // fallback, nech sa UI zosynchronizuje
            //dispatch({ type: "updateTaskViewed", payload: taskId, value: value });
        }
    };

    
    function MailIconTemplate(props) {
    const rowData = props.cell.getRow().getData();
    const isUnread = rowData?.is_unread;
    return (
    <div className="flex items-center gap-2">
        {isUnread ? (
        <button type="button" title={t('Common.MarkAsRead')} onClick={() => markAsViewed(rowData.id, false)} className="hover:opacity-75">
            <UnseenIcon />
        </button>
        ) : (
        <button type="button" title={t('Common.MarkAsUnread')} onClick={() => markAsViewed(rowData.id, true)} className="hover:opacity-75">
            <SeenIcon />
        </button>
        )}
    </div>
    );
    }

    const textHeaderFilter = useCallback((headerValue, rowValue) => {
        if (!headerValue) return true;
        return normalizeText(rowValue).includes(normalizeText(headerValue));
    }, []);

    const remoteHeaderFilter = useCallback(() => true, []);

    const serviceTaskAuditTailColumns = useMemo(() => {
        const cols = buildAuditTabulatorColumns({
            profile: TABULATOR_AUDIT_PROFILES.contractorLastTouched,
            includeId: false,
            dateFormat: dateFmt,
            dateTimeFormat: dateTimeFmt,
            getUserColor,
            getUserInitials,
            textHeaderFilter,
            remotePassthrough: true,
        });
        return cols.map((col) => {
            if (col.field === 'created_at') return { ...col, title: t('Common.TicketCreatedAt') };
            if (col.field === 'updated_at') return { ...col, title: t('Common.Column.UpdatedAt') };
            return col;
        });
    }, [dateFmt, dateTimeFmt, getUserColor, getUserInitials, textHeaderFilter]);

    const statusFilterOptions = useMemo(
        () => (state.service_states || []).map((s) => ({ label: s.name, value: Number(s.id) })).sort((a, b) => a.label.localeCompare(b.label, 'sk')),
        [state.service_states]
    );

    const columns = useMemo(
        () => [
            {
                title: '',
                field: 'editor',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                formatter: reactFormatter(<EditRowFormatter />),
                resizable: false,
                frozen: true,
                print: false,
                download: false,
            },
            {
                title: '',
                field: 'status_indicator',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                formatter: reactFormatter(<StatusIndicatorFormatter />),
                resizable: false,
                frozen: true,
                print: false,
                download: false,
                headerFilter: 'list',
                headerFilterParams: { values: { '': t('Common.FilterAll'), red: '🔴', orange: '🟠', green: '🟢' }, clearable: true },
                headerFilterFunc: (headerValue, rowValue, rowData) => {
                    if (!headerValue) return true;
                    return getStatusIndicatorFilterValue(rowData, state.module_settings) === headerValue;
                },
            },
            {
                field: 'contractor_id',
                visible: false,
                width: 0,
                minWidth: 0,
                maxWidth: 0,
                resizable: false,
                headerSort: false,
                print: false,
                download: false,
            },
            buildTabulatorIdColumn({
                frozen: true,
                headerFilterFunc: remoteHeaderFilter,
            }),
            {
                title: t('Common.Type'),
                field: 'type',
                formatter: reactFormatter(<TypeFormatter />),
                minWidth: 120,
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: [
                        { label: t('Common.Notification'), value: 'Notification' },
                        { label: t('Common.Error'), value: 'Error' },
                        { label: t('Common.Task'), value: 'Task' },
                        { label: t('Common.TechnicalChange'), value: 'TechChange' },
                        { label: 'Povolenie', value: 'Permission' },
                        { label: 'Potreba', value: 'Need' },
                        { label: t('Common.Loan'), value: 'Borrow' },
                        { label: 'Nehoda', value: 'Emergency' },
                    ].sort((a, b) => a.label.localeCompare(b.label, 'sk')),
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Read'),
                field: 'is_unread',
                minWidth: 100,
                formatter: reactFormatter(<MailIconTemplate />),
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: [
                        { label: t('Common.Unread'), value: 'true' },
                        { label: t('Common.Read'), value: 'false' },
                    ],
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.TicketNumber'),
                field: 'defined_id',
                minWidth: 150,
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Name'),
                field: 'theme',
                minWidth: 250,
                widthGrow: 2,
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Machine'),
                field: 'machine.name',
                minWidth: 200,
                formatter: reactFormatter(<MachineNameFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Status'),
                field: 'status_id',
                minWidth: 200,
                formatter: reactFormatter(<StatusFormatter />),
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: { placeholder: t('Common.All'), options: statusFilterOptions },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('ServiceTaskTable.Col.Deadline'),
                field: 'waiting_for_action_by',
                minWidth: 220,
                formatter: reactFormatter(<AwaitingUserFormatter />),
                sorter: awaitingUserSorter,
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            ...serviceTaskAuditTailColumns,
        ],
        [statusFilterOptions, serviceTaskAuditTailColumns, remoteHeaderFilter, state.module_settings]
    );

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useTabulatorScrollArrows(getTable);
    
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
    const closeMenu = useCallback(() => {
        setTimeout(() => {
            OverflowMenuProvider.setVisible?.(null);
            setExpandedKeys({});
        }, 0);
    }, []);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: MAINTENANCE_TASK_STATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


    const hasApplicableStandardMask = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeTaskStateListColumnVisibilityFromSaved),
        [state.standard_mask_filters]
    );

    const openMaskDialog = useCallback(
        createOpenMaskDialog({
            columnsVisible,
            setColumnsVisible,
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: mergeTaskStateListColumnVisibilityFromSaved,
            setMaskVisible,
            closeMenu,
        }),
        [columnsVisible, closeMenu]
    );

    const saveUserMaskColumns = useCallback(
        createSaveUserMaskColumns({
            maskPage: MASK_PAGE,
            getTable,
            setUserMaskFilter,
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            columnsVisible,
            setColumnsVisible,
            setMaskVisible,
            toast,
        }),
        [columnsVisible, getTable, setUserMaskFilter, toast]
    );

    const confirmSaveStandardMask = useCallback(
        createConfirmSaveStandardMask({
            maskPage: MASK_PAGE,
            getTable,
            setStandardMaskFilter,
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            toast,
        }),
        [getTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutToUserMask = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
            maskPage: MASK_PAGE,
            state,
            setUserMaskFilter,
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: mergeTaskStateListColumnVisibilityFromSaved,
            toast,
            closeMenu,
            onAppliedToTable: ({ colsForSave, attributes }) => {
                const table = getTable();
                if (!table) return;
                isRestoringRef.current = true;
                applyServiceTaskColumnLayout(table, attributes, TASK_STATE_LIST_COLUMN_FIELD_ORDER, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS);
                applyTaskStateListDataColumnVisibility(table, colsForSave);
                setColumnsVisible(colsForSave);
                setTimeout(() => {
                    isRestoringRef.current = false;
                    captureHScroll();
                    refreshFromStart();
                }, 0);
            },
        }),
        [state, closeMenu, getTable, setUserMaskFilter, toast]
    );

    const setMask = useCallback(
        createMaskSetFieldHandler({
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            columnsVisible,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: applyTaskStateListDataColumnVisibility,
            toast,
        }),
        [columnsVisible, getTable, toast]
    );

    const maskSelectAll = useCallback(
        createMaskSelectAllHandler({
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: applyTaskStateListDataColumnVisibility,
        }),
        [getTable]
    );

    const maskDeselectAll = useCallback(
        createMaskDeselectAllHandler({
            defaultColumnVisibility: DEFAULT_TASK_STATE_LIST_COLUMN_VISIBILITY,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: applyTaskStateListDataColumnVisibility,
        }),
        [getTable]
    );

    const handleClickOutside = (event) => {
      if (event.target.closest('[data-overflow-trigger]')) return;
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
          OverflowMenuProvider.setVisible?.(null);
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel) return;
        const getId = (data) => data?.id ?? data?.task_id ?? data?.task?.id ?? null;
        const onCreated = (data) => {
            const id = getId(data);
            if (id == null || !getTable()?.getRow) return;
            getRequest(`/api/service_tasks/${id}`)
                .then((res) => {
                    const row = res?.data ?? res;
                    if (!row || row?.type !== 'Error') return;
                    const table = getTable();
                    const rc = table?.getRow?.(row.id);
                    if (rc) rc.update(row).catch(() => {});
                    else table?.addData?.([row]);
                    pendingRowIdsRef.current.add(row.id);
                    if (isTableVisible()) scheduleRedraw();
                    else needsRedrawRef.current = true;
                })
                .catch(() => {});
        };
        const onUpdated = (data) => {
            const id = getId(data);
            if (id == null || !getTable()?.getRow) return;
            getRequest(`/api/service_tasks/${id}`)
                .then((res) => {
                    const row = res?.data ?? res;
                    if (!row || row?.type !== 'Error') return;
                    const table = getTable();
                    const rc = table?.getRow?.(row.id);
                    if (rc) rc.update(row).catch(() => {});
                    else table?.addData?.([row]);
                    pendingRowIdsRef.current.add(row.id);
                    if (isTableVisible()) scheduleRedraw();
                    else needsRedrawRef.current = true;
                })
                .catch(() => {});
        };
        const onDeleted = (data) => {
            const id = getId(data);
            if (id != null) {
                const row = getTable()?.getRows?.().find((r) => r.getData().id === id);
                if (row) row.delete();
            }
        };
        channel.bind('service_task.created', onCreated);
        channel.bind('service_task.updated', onUpdated);
        channel.bind('service_task.deleted', onDeleted);
        return () => {
            channel.unbind('service_task.created', onCreated);
            channel.unbind('service_task.updated', onUpdated);
            channel.unbind('service_task.deleted', onDeleted);
        };
    }, [getTable, isTableVisible, scheduleRedraw]);

    // ResizeObserver: keď sa záložka znova zobrazí (návrat z detailu), prekresli tabuľku – oprava neúplného náhľadu (rovnako ako intr003)
    const lastContainerHeightRef = useRef(0);
    useEffect(() => {
        const el = elementRef.current;
        if (!el) return;
        const ro = new ResizeObserver(() => {
            const h = el.clientHeight;
            if (h > 0) {
                const wasHidden = lastContainerHeightRef.current <= 0;
                lastContainerHeightRef.current = h;
                if (wasHidden) requestAnimationFrame(() => getTable()?.redraw?.(true));
                else if (needsRedrawRef.current) scheduleRedraw();
            } else {
                lastContainerHeightRef.current = 0;
            }
        });
        ro.observe(el);
        return () => ro.disconnect();
    }, [scheduleRedraw, getTable]);

    

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          cleanSorters,
          captureHScroll,
          refreshFromStart,
          closeMenu,
          openMaskDialog,
          openChosenNotificationPreferences,
          hasApplicableStandardMask,
          confirmApplyStandardLayoutToUserMask,
          itemRenderer,
        }),
      }
    ];

    const exportToExcel = () => {
        const excel_type = {};
        let error_records = ref.current.getData("active").map((x) => {
        let id = x.id;
        let nazov_stroja = x?.machine?.name;
        let druh_stroja = x?.maintenance_type?.machine_type?.name;
        let nazov_planovaneho_ukonu = x?.maintenance_type?.name;
        let posledne_vykonanie = x?._children?.length > 0 ? DateTime.fromISO(x?._children[0]?.last_execution_date).toFormat(dateFmt) : t('Common.NotPerformed');
        let nasledujuce_vykonanie = x?._children?.length > 0 ? DateTime.fromISO(x?._children[0]?.next_execution_date).toFormat(dateFmt) : t('Common.NotPerformed');
        let expiracia = "";
        if(x?.deactivation_date!=null && x?.deactivation_date!="")expiracia = "DEA";
        else{
          if(x?._children?.length > 0){           
              if(new Date(x?._children[0]?.next_execution_date) < new Date()){
                  expiracia="NOK";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 15))){
                expiracia="15-";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 30))){
                expiracia="30-";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 45))){
                expiracia="45-";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 60))){
                expiracia="60-";
              }
              else expiracia="61+";
          }
          else expiracia="NOK";
        }
        let stav = "";
        if(x?.deactivation_date!=null && x?.deactivation_date!="") stav = "DEA";
        else{
          if(x?._children?.length > 0){           
              if(new Date(x?._children[0]?.next_execution_date) < new Date()){
                  stav = "NOK";
              }
              else stav = "OK"
          }
          else stav = "NOK";
        }
        let interval = x?.maintenance_type?.interval;
        let servisna_firma = x?.company?.name;
        let servisny_technik = x?.company?.company_contact?.name;
        let zodpovedna_osoba = x?.maintenance_type?.employee?.name;
        let popis_planevaneho_ukoonu = x?.maintenance_type?.description;
        let popis = x?.description;
        return {
            id,nazov_stroja,druh_stroja,nazov_planovaneho_ukonu,posledne_vykonanie,nasledujuce_vykonanie,expiracia,stav,
            interval,servisna_firma,servisny_technik,zodpovedna_osoba,popis_planevaneho_ukoonu,popis
    
        };
        }).sort((a, b) => (parseInt(a.specific_id) > parseInt(b.specific_id)) ? -1 : 1);
        const worksheet = XLSX.utils.json_to_sheet(error_records);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Poruchy podla stavu");
        const excelBuffer = XLSX.writeFile(workbook, "poruchy_podla_stavu.xlsx",{bookSST:true});//{ bookType: 'xlsx', type: 'array' });
      };

    const onSelectRow = (data, rows) => {
        setEditIcon(true);
        setDeleteIcon(true);
        if(ref.current.getSelectedData().length>0){
          if(ref.current.getSelectedData().length == 1){
            if(user.permissions?.includes("edit maintenance"))setEditIcon(false);
          }
          if(user.permissions?.includes("delete maintenance"))setDeleteIcon(false);
        }
    };

    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor!="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue("");ref.current.clearFilter();}}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => exportToExcel()}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon /></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Print.Title.MaintenanceTaskStateList'),"MaintenanceTaskStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("MaintenanceTaskStateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        {canSetStandardMask ? (
          <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
            <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMask} className="flex items-center justify-center">
              <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
            </button>
          </div>
        ) : null}
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2">
    <div ref={elementRef}>
    <ReactTabulator
      onRef={(r) => (ref.current = r.current)}
      className='h-[calc(100vh_-_193px)]'
      columns={columns}
      events={{
        tableBuilt: () => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            if (preview == null) {
                const effective = getEffectiveMask(MASK_PAGE, state);
                if (effective?.type === 'user' && effective.userMask) {
                    restoreServiceTaskUserMaskToTable(table, effective.userMask, {
                        canonicalFieldOrder: TASK_STATE_LIST_COLUMN_FIELD_ORDER,
                        forceFrozenId: true,
                        setColumnsVisible,
                        clearHeaderFiltersWhenEmpty: true,
                        applyColumnVisibilityFn: (tbl, jc, setVis) => {
                            const merged = mergeTaskStateListColumnVisibilityFromSaved(jc);
                            setVis(merged);
                            applyTaskStateListDataColumnVisibility(tbl, merged);
                        },
                    });
                } else if (effective?.type === 'standard' && effective.standardMask) {
                    const m = effective.standardMask;
                    const jsonColumns = safeParse(m.columns, {});
                    applyServiceTaskColumnLayout(table, safeParse(m.attributes, []), TASK_STATE_LIST_COLUMN_FIELD_ORDER, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS);
                    if (jsonColumns && typeof jsonColumns === 'object') {
                        const merged = mergeTaskStateListColumnVisibilityFromSaved(jsonColumns);
                        setColumnsVisible(merged);
                        applyTaskStateListDataColumnVisibility(table, merged);
                    }
                } else {
                    applyTaskStateListDataColumnVisibility(table, columnsVisible);
                }
            } else {
                applyTaskStateListDataColumnVisibility(table, columnsVisible);
            }
            setTimeout(() => {
                isRestoringRef.current = false;
            }, 0);
            tableBuiltRef.current = true;
            refreshFromStart();
        },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => {
            if (!isRestoringRef.current) {
                captureHScroll();
                refreshFromStart();
            }
        },
        sortChanged: () => {
            if (!isRestoringRef.current) {
                captureHScroll();
                refreshFromStart();
            }
        },
        renderComplete: () => { restoreHScroll(); },
      }}
      options={{
        layout: "fitColumns",
        rowHeight: 42,
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        placeholder: t('Common.NoData'),
        height: "calc(100vh - 193px)",
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        progressiveLoadDelay: 200,
        pagination: false,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        headerSortTristate: true,
        ajaxURL: "/api/service_tasks/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        ajaxRequesting: () => {
            if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
            const table = getTable();
            if (table?.initialized) table.alert?.(t('Common.LoadingData'));
            return true;
        },
        ajaxResponse: (url, params, response) => { getTable()?.clearAlert?.(); return response; },
        ajaxError: () => { getTable()?.clearAlert?.(); },
        renderHorizontal: "virtual",
        movableColumns: true,
        printAsHtml:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceTaskStateList'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),
        printRowRange: "active",
      }}/>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
            <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
          </div>
        {columns.map((item) => {
          if (!item.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                    return <div 
                        key={item.field} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <MaintenanceMaskDialogCheckbox field={item.field} inputId={`mts-mask-${item.field}`} title={item.title || item.field} columnsVisible={columnsVisible} onChange={setMask} /><label htmlFor={`mts-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title || item.field}</label>    
                    </div> 
                })} 
            <button type="button" onClick={saveUserMaskColumns} className='m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700'>{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
</div> 
        </>
    )
}